// import React from "react";
// import {
//   Box,
//   Typography,
//   Paper,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Chip
// } from "@mui/material";
// import { motion } from "framer-motion";
// import dayjs from "dayjs";
// import { FiTrendingDown } from "react-icons/fi";

// export default function LowStockProducts() {
//   // 🔹 Example response data
//   const lowStockProducts = [
//     {
//       _id: "69006be65a3aea03abb834f8",
//       productCode: "PRD-N4IIX8HE6G",
//       title: "Towel XL",
//       ownership: "Own Product",
//       availableQuantity: 12,
//       minimumStockQuantity: 10,
//       isFree: true,
//       updatedAt: "2025-11-03T10:57:40.361Z",
//       stockStatus: "near-low"
//     }
//   ];

//   return (
//     <Paper
//       component={motion.div}
//       elevation={3}
//       sx={{
//         borderRadius: 4,
//         p: 3,
//         mt: 4,
//         background: "linear-gradient(135deg, #f9fafb, #ffffff)"
//       }}
//     >
//       {/* Header */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           mb: 3
//         }}
//       >
//         <Typography
//           variant="h5"
//           sx={{
//             fontWeight: 700,
//             textAlign: "center",
//             color: "text.primary",
//             fontFamily: "Mulish, sans-serif"
//           }}
//         >
//           Low Stock Products
//         </Typography>

//         <Typography variant="body2" sx={{ color: "text.secondary" }}>
//           {lowStockProducts.length} item
//           {lowStockProducts.length > 1 ? "s" : ""} nearing low stock
//         </Typography>
//       </Box>

//       {/* Table */}
//       <Table>
//         <TableHead>
//           <TableRow sx={{ backgroundColor: "#f4f6f8" }}>
//             <TableCell sx={{ fontWeight: 600 }}>Product Title</TableCell>
//             {/* <TableCell sx={{ fontWeight: 600 }}>Ownership</TableCell> */}
//             <TableCell sx={{ fontWeight: 600 }}>Available</TableCell>
//             <TableCell sx={{ fontWeight: 600 }}>Min. Required</TableCell>
//             {/* <TableCell sx={{ fontWeight: 600 }}>Free</TableCell> */}
//             {/* <TableCell sx={{ fontWeight: 600 }}>Stock Status</TableCell> */}
//             {/* <TableCell sx={{ fontWeight: 600 }}>Last Updated</TableCell> */}
//           </TableRow>
//         </TableHead>

//         <TableBody>
//           {lowStockProducts.map(product =>
//             <TableRow key={product._id}>
//               <TableCell sx={{ fontWeight: 600, color: "#000000ff" }}>
//                 {product.title}
//                 <Typography sx={{ fontSize: "11px", color: "text.secondary" }}>
//                   Last Updated:{dayjs(product.updatedAt).format("DD MMM, YYYY")}
//                 </Typography>
//               </TableCell>

//               {/* <TableCell>
//                 <Chip
//                   label={product.ownership}
//                   color={
//                     product.ownership === "Own Product"
//                       ? "primary"
//                       : "secondary"
//                   }
//                   size="small"
//                 />
//               </TableCell> */}

//               <TableCell sx={{ fontWeight: 600, color: "#f97316" }}>
//                 {product.availableQuantity}
//               </TableCell>

//               <TableCell sx={{ fontWeight: 600, color: "#9ca3af" }}>
//                 {product.minimumStockQuantity}
//               </TableCell>

//               {/* <TableCell>
//                 <Chip
//                   label={product.isFree ? "Yes" : "No"}
//                   color={product.isFree ? "success" : "default"}
//                   size="small"
//                 />
//               </TableCell> */}

//               {/* <TableCell>
//                 <Chip
//                   label={product.stockStatus.replace("-", " ")}
//                   color="warning"
//                   size="small"
//                   sx={{
//                     textTransform: "capitalize",
//                     fontWeight: 600,
//                     backgroundColor: "#fef3c7",
//                     color: "#92400e"
//                   }}
//                 />
//               </TableCell> */}
//               {/*
//               <TableCell sx={{ color: "text.secondary" }}>
//                 {dayjs(product.updatedAt).format("DD MMM, YYYY")}
//               </TableCell> */}
//             </TableRow>
//           )}
//         </TableBody>
//       </Table>
//     </Paper>
//   );
// }

import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Alert
} from "@mui/material";
import { motion } from "framer-motion";
import dayjs from "dayjs";
import { getData } from "../Webservice/Webservice";

export default function LowStockProducts() {
  const [lowStockData, setLowStockData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLowStockProducts = async () => {
      try {
        setLoading(true);
        setError(null);
        const tokenValue = sessionStorage.getItem("token");
        const token = tokenValue ? `Bearer ${tokenValue}` : "";
        const data = await getData("dashboard/low-stock", null, token);

        if (data && data.success && data.lowStockProducts) {
          setLowStockData(data);
        } else {
          throw new Error("Invalid low stock products response format");
        }
      } catch (err) {
        setError(err.message || "Failed to load low stock products");
      } finally {
        setLoading(false);
      }
    };

    fetchLowStockProducts();
  }, []);

  // Show loading state
  if (loading) {
    return (
      <Paper
        component={motion.div}
        elevation={3}
        sx={{
          borderRadius: 4,
          p: 3,
          mt: 4,
          background: "linear-gradient(135deg, #f9fafb, #ffffff)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 400
        }}
      >
        <CircularProgress />
      </Paper>
    );
  }

  // Show error state
  if (error) {
    return (
      <Paper
        component={motion.div}
        elevation={3}
        sx={{
          borderRadius: 4,
          p: 3,
          mt: 4,
          background: "linear-gradient(135deg, #f9fafb, #ffffff)"
        }}
      >
        <Alert severity="error">
          {error}
        </Alert>
      </Paper>
    );
  }

  // Show data when available
  if (!lowStockData) {
    return null;
  }

  const { lowStockProducts, totalCount } = lowStockData;

  return (
    <Paper
      component={motion.div}
      elevation={3}
      sx={{
        borderRadius: 4,
        p: 3,
        mt: 4,
        background: "linear-gradient(135deg, #f9fafb, #ffffff)"
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            textAlign: "center",
            color: "text.primary",
            fontFamily: "Mulish, sans-serif"
          }}
        >
          Low Stock Products
        </Typography>

        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {totalCount} item
          {totalCount > 1 ? "s" : ""} nearing low stock
        </Typography>
      </Box>

      {/* Table */}
      <Table>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#f4f6f8" }}>
            <TableCell sx={{ fontWeight: 600 }}>Product Title</TableCell>
            {/* <TableCell sx={{ fontWeight: 600 }}>Ownership</TableCell> */}
            <TableCell sx={{ fontWeight: 600 }}>Available</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Min. Required</TableCell>
            {/* <TableCell sx={{ fontWeight: 600 }}>Free</TableCell> */}
            {/* <TableCell sx={{ fontWeight: 600 }}>Stock Status</TableCell> */}
            {/* <TableCell sx={{ fontWeight: 600 }}>Last Updated</TableCell> */}
          </TableRow>
        </TableHead>

        <TableBody>
          {lowStockProducts.map(product =>
            <TableRow key={product._id}>
              <TableCell sx={{ fontWeight: 600, color: "#000000ff" }}>
                {product.title}
                <Typography sx={{ fontSize: "11px", color: "text.secondary" }}>
                  Last Updated:{" "}
                  {dayjs(product.updatedAt).format("DD MMM, YYYY")}
                </Typography>
              </TableCell>

              {/* <TableCell>
                <Chip
                  label={product.ownership}
                  color={
                    product.ownership === "Own Product"
                      ? "primary"
                      : "secondary"
                  }
                  size="small"
                />
              </TableCell> */}

              <TableCell sx={{ fontWeight: 600, color: "#f97316" }}>
                {product.availableQuantity}
              </TableCell>

              <TableCell sx={{ fontWeight: 600, color: "#9ca3af" }}>
                {product.minimumStockQuantity}
              </TableCell>

              {/* <TableCell>
                <Chip
                  label={product.isFree ? "Yes" : "No"}
                  color={product.isFree ? "success" : "default"}
                  size="small"
                />
              </TableCell> */}

              {/* <TableCell>
                <Chip
                  label={product.stockStatus.replace("-", " ")}
                  color="warning"
                  size="small"
                  sx={{
                    textTransform: "capitalize",
                    fontWeight: 600,
                    backgroundColor: "#fef3c7",
                    color: "#92400e"
                  }}
                />
              </TableCell> */}
              {/* 
              <TableCell sx={{ color: "text.secondary" }}>
                {dayjs(product.updatedAt).format("DD MMM, YYYY")}
              </TableCell> */}
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Paper>
  );
}
